import React, { type HTMLProps } from 'react';
import c from 'classnames';

import s from './ShopCardRoot.scss';

export interface Props {
  width: number;
  height?: number;
  className?: string;
  'aria-hidden'?: HTMLProps<HTMLDivElement>['aria-hidden'];
  children: React.ReactNode;
}

const ShopCardRoot: React.FC<Props> = ({
  width,
  height,
  className,
  'aria-hidden': ariaHidden,
  children,
}) => {
  return (
    <div
      className={c(s['root'], className)}
      style={{ width, height }}
      aria-hidden={ariaHidden}
    >
      {children}
    </div>
  );
};

ShopCardRoot.displayName = 'ShopCardRoot';

export default ShopCardRoot;
